// @flow
import Case from 'case'
import diacritics from 'diacritics'

export function slugify(str: string): string {
  return diacritics.remove(Case.kebab(str))
}

export function slidesLinkFor(title: string): string {
  return `https://res.cloudinary.com/pubmet/image/upload/v2/slides/${slugify(
    title,
  )}.pdf`
}
